import React from 'react';
import { Chip, Typography, Icon } from '@scale/scaleui';
import SAlert from 'react-s-alert';

export const ClickableCopyToClipboardChip = (text: string) => {
  const variable = `{{${text}}}`;
  return (
    <Chip
      className="p-1"
      label={variable}
      onClick={() => {
        navigator.clipboard.writeText(variable);
        SAlert.success(`Copied to "${variable}" to clipboard`);
      }}
    />
  );
};
const AvailableVariablesList = ({ availableVariables }: { availableVariables: string[] }) => {
  return (
    <div>
      <div className="flex items-center">
        <Typography.Paragraph2 className="text-neutral-600 inline-block mr-4">
          Available variables
        </Typography.Paragraph2>

        <div className="flex flex-row gap-1 flex-wrap">
          {availableVariables.map(header => ClickableCopyToClipboardChip(header))}
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Icon icon={['fas', 'info-circle']} size="sm" variant="neutral" />
        <Typography.Paragraph3>
          The values for available variables will be auto-populated based on the receiving user or
          CSV row.
        </Typography.Paragraph3>
      </div>
    </div>
  );
};

export default AvailableVariablesList;
